// textPreview.js — the short preview a long text also carries, sealed, for its notification.
// The phone's services/textPreview.ts, line for line: a push carries at most 4 KB, so a long
// message's own cipher is dropped from it, and without this sealed preview the other phone's
// notification could only say "encrypted message" (app: services/longText.ts).

/** a text longer than this (UTF-8 bytes) also gets a sealed preview */
export const PREVIEW_OVER_BYTES = 1000;
/** how much of it a notification shows */
export const PREVIEW_CHARS = 280;

export function utf8Bytes(s) {
  let n = 0;
  for (let i = 0; i < s.length; i += 1) {
    const c = s.charCodeAt(i);
    if (c < 0x80) n += 1;
    else if (c < 0x800) n += 2;
    else if (c >= 0xd800 && c <= 0xdbff) { n += 4; i += 1; }
    else n += 3;
  }
  return n;
}

export const needsPreview = (text) => typeof text === 'string' && utf8Bytes(text) > PREVIEW_OVER_BYTES;

/** the first PREVIEW_CHARS characters (never half an emoji), whitespace-collapsed, with an ellipsis */
export function previewText(text) {
  const flat = String(text || '').replace(/\s+/g, ' ').trim();
  const chars = Array.from(flat);
  return chars.length <= PREVIEW_CHARS ? flat : `${chars.slice(0, PREVIEW_CHARS).join('').trimEnd()}…`;
}
